import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Feedback } from '../components/Feedback';
import { useAuth } from '../contexts/auth-context';
import { ApiError } from '../services/api';

/** Cadastro do criador/streamer. Com sucesso, já entra logado na dashboard. */
export function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError(null);
    setIsSubmitting(true);

    try {
      await register({ name, email, username, password });
      navigate('/dashboard');
    } catch (err) {
      // Erros de validação da API trazem a lista de campos — mostra o primeiro
      if (err instanceof ApiError && err.issues?.length) {
        setError(err.issues[0].error);
      } else {
        setError(err instanceof Error ? err.message : 'Erro inesperado ao cadastrar.');
      }
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <main className="auth-page">
      <form className="card form" onSubmit={handleSubmit}>
        <h1 className="form__title">Criar conta de criador</h1>

        <div className="form__field">
          <label className="form__label" htmlFor="name">
            Nome
          </label>
          <input
            className="form__input"
            id="name"
            type="text"
            autoComplete="name"
            required
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </div>

        <div className="form__field">
          <label className="form__label" htmlFor="email">
            E-mail
          </label>
          <input
            className="form__input"
            id="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>

        <div className="form__field">
          <label className="form__label" htmlFor="username">
            Nome de usuário
          </label>
          <input
            className="form__input"
            id="username"
            type="text"
            autoComplete="username"
            required
            minLength={3}
            maxLength={30}
            pattern="[a-z0-9_\-]+"
            title="Apenas letras minúsculas, números, hífen e underline"
            value={username}
            onChange={(event) => setUsername(event.target.value.toLowerCase())}
          />
          <p className="form__help">
            Será o seu link público: <code>/{username || 'seu-usuario'}</code>
          </p>
        </div>

        <div className="form__field">
          <label className="form__label" htmlFor="password">
            Senha
          </label>
          <input
            className="form__input"
            id="password"
            type="password"
            autoComplete="new-password"
            required
            minLength={8}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
          <p className="form__help">Mínimo de 8 caracteres.</p>
        </div>

        {error && <Feedback kind="error">{error}</Feedback>}

        <button className="button button--primary" type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Criando conta…' : 'Criar conta'}
        </button>

        <p className="form__footer">
          Já tem conta? <Link to="/login">Entrar</Link>
        </p>
      </form>
    </main>
  );
}
